import React from 'react';
import { FaqTemplate } from 'ui/templates';
import { useSelector } from 'react-redux';
import { getAllList } from 'ducks/settings';
const Faq = () => {
    const settings = useSelector(getAllList);
    return (React.createElement(FaqTemplate, { settings: settings }));
};
export default Faq;
